import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const PROJECT_TYPES = [
  { key: 'identite',     label: 'Identité Visuelle' },
  { key: 'ui',           label: 'UI / UX' },
  { key: 'motion',       label: 'Motion Design' },
  { key: 'print',        label: 'Print & Édition' },
  { key: 'illustration', label: 'Illustration' },
  { key: 'autre',        label: 'Autre' },
];

const STEPS = [
  { num: '01', title: 'Vous envoyez le formulaire', desc: 'Je reçois vos infos et prends connaissance de votre projet.' },
  { num: '02', title: 'On se parle', desc: 'Un call de 20 min pour affiner le brief et répondre à vos questions.' },
  { num: '03', title: 'Devis personnalisé', desc: 'Je vous envoie une proposition claire avec planning et budget.' },
  { num: '04', title: 'On crée', desc: "Signature du contrat, acompte, et c'est parti." },
];

const BAND_ITEMS = [
  { num: '01', title: 'Devis Gratuit',  desc: 'Chaque projet commence par un échange sans engagement pour comprendre vos besoins.' },
  { num: '02', title: 'Réponse Rapide', desc: "Je m'engage à répondre à chaque message sous 24h ouvrées, sans exception." },
  { num: '03', title: '100% Remote',    desc: 'Je travaille avec des clients partout en Europe. Fuseaux horaires gérés.' },
  { num: '04', title: 'Contrat Signé',  desc: 'Un contrat clair avant chaque projet. Vos droits et les miens sont protégés.' },
];

/* Sauvegarde la demande dans localStorage */
function saveRequest(data) {
  const existing = JSON.parse(localStorage.getItem('contact_requests') || '[]');
  const newReq = {
    id: Date.now(),
    receivedAt: new Date().toISOString(),
    read: false,
    ...data,
  };
  localStorage.setItem('contact_requests', JSON.stringify([newReq, ...existing]));
}

export default function Contact() {
  const [contactInfo, setContactInfo] = useState({
    email: 'hello@heyimpurp.fr',
    phone: 'A Venir',
    location: 'France — Remote worldwide',
    avail: 'Disponible pour de nouveaux projets',
  });
  const [selectedType, setSelectedType] = useState('');
  const [form, setForm] = useState({
    firstname: '', lastname: '', email: '', company: '',
    budget: '', timeline: '', message: '', source: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    document.title = 'Contact — HEYIMPURP';
    const ci = JSON.parse(localStorage.getItem('contact_info') || 'null');
    if (ci) setContactInfo(c => ({ ...c, ...ci }));
  }, []);

  const update = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
    if (errors[field]) setErrors(er => ({ ...er, [field]: false }));
  };

  const handleSubmit = () => {
    const required = ['firstname', 'lastname', 'email', 'message'];
    const newErrors = {};
    required.forEach(f => { if (!form[f].trim()) newErrors[f] = true; });
    if (Object.keys(newErrors).length) { setErrors(newErrors); return; }

    setLoading(true);
    setTimeout(() => {
      saveRequest({ ...form, projectType: selectedType });
      setLoading(false);
      setSuccess(true);
    }, 900);
  };

  return (
    <>
      <Nav />

      {/* HERO */}
      <div className="contact-hero">
        <div className="hero-left">
          <div className="page-label">Travaillons ensemble</div>
          <h1 className="contact-page-title">PARLONS<br /><em>PROJET</em></h1>
          <div className="availability">{contactInfo.avail}</div>
        </div>
        <div className="hero-right">
          <div className="info-card">
            <div>
              <div className="info-label">E-mail</div>
              <div className="info-value"><a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a></div>
            </div>
            <span className="info-icon">✉</span>
          </div>
          <div className="info-card">
            <div>
              <div className="info-label">Téléphone</div>
              <div className="info-value"><a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>{contactInfo.phone}</a></div>
            </div>
            <span className="info-icon">☎</span>
          </div>
          <div className="info-card">
            <div>
              <div className="info-label">Localisation</div>
              <div className="info-value">{contactInfo.location}</div>
            </div>
            <span className="info-icon">◎</span>
          </div>
          <div className="info-card">
            <div>
              <div className="info-label">Délai de réponse</div>
              <div className="info-value">Sous 24h ouvrées</div>
            </div>
            <span className="info-icon">◷</span>
          </div>
          <div className="socials">
            <a href="https://behance.net/heyimpurp" className="social-btn">Behance</a>
            <a href="#" className="social-btn">LinkedIn</a>
            <a href="#" className="social-btn">Instagram</a>
            <a href="#" className="social-btn">Dribbble</a>
          </div>
        </div>
      </div>

      {/* FORM */}
      <div className="form-section">
        <div className="form-left">
          <div>
            <h2 className="form-left-title">DÉMARRER<br />UN PROJET</h2>
            <p className="form-left-desc">Remplissez le formulaire et je vous reviens avec un premier échange pour cerner vos besoins avant de rédiger un devis.</p>
          </div>
          <div className="form-steps">
            {STEPS.map(s => (
              <div className="form-step" key={s.num}>
                <span className="step-num">{s.num}</span>
                <div className="step-text"><strong>{s.title}</strong>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="form-right">
          {!success ? (
            <>
              <div className="form-title">VOTRE PROJET</div>

              <div className="form-label" style={{ marginBottom: 10 }}>Type de projet</div>
              <div className="type-selector">
                {PROJECT_TYPES.map(t => (
                  <div
                    key={t.key}
                    className={`type-btn${selectedType === t.key ? ' selected' : ''}`}
                    onClick={() => setSelectedType(t.key)}
                  >
                    {t.label}
                  </div>
                ))}
              </div>

              <div className="form-row">
                <div>
                  <label className="form-label">Prénom *</label>
                  <input type="text" className="form-input" placeholder="Votre prénom" value={form.firstname} onChange={update('firstname')} style={errors.firstname ? { borderColor: 'var(--red)' } : {}} />
                </div>
                <div>
                  <label className="form-label">Nom *</label>
                  <input type="text" className="form-input" placeholder="Votre nom" value={form.lastname} onChange={update('lastname')} style={errors.lastname ? { borderColor: 'var(--red)' } : {}} />
                </div>
              </div>

              <div className="form-row">
                <div>
                  <label className="form-label">E-mail *</label>
                  <input type="email" className="form-input" placeholder="votre@email.com" value={form.email} onChange={update('email')} style={errors.email ? { borderColor: 'var(--red)' } : {}} />
                </div>
                <div>
                  <label className="form-label">Entreprise / Marque</label>
                  <input type="text" className="form-input" placeholder="Optionnel" value={form.company} onChange={update('company')} />
                </div>
              </div>

              <div className="form-row">
                <div>
                  <label className="form-label">Budget estimé</label>
                  <select className="form-select form-input" value={form.budget} onChange={update('budget')}>
                    <option value="">Sélectionner...</option>
                    <option value="500">Moins de 500€</option>
                    <option value="1000">500€ — 1 000€</option>
                    <option value="2000">1 000€ — 2 000€</option>
                    <option value="5000">2 000€ — 5 000€</option>
                    <option value="plus">Plus de 5 000€</option>
                  </select>
                </div>
                <div>
                  <label className="form-label">Timeline souhaitée</label>
                  <select className="form-select form-input" value={form.timeline} onChange={update('timeline')}>
                    <option value="">Sélectionner...</option>
                    <option value="urgent">Urgent (&lt; 2 semaines)</option>
                    <option value="normal">Normal (1 mois)</option>
                    <option value="flexible">Flexible (+ de 1 mois)</option>
                    <option value="nsp">Je ne sais pas encore</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Décrivez votre projet *</label>
                <textarea
                  className="form-textarea"
                  placeholder="Parlez-moi de votre projet, de vos objectifs, de votre cible, de ce qui vous inspire..."
                  value={form.message}
                  onChange={update('message')}
                  style={errors.message ? { borderColor: 'var(--red)' } : {}}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Comment avez-vous entendu parler de moi ?</label>
                <select className="form-select form-input" value={form.source} onChange={update('source')}>
                  <option value="">Sélectionner...</option>
                  <option value="bouche">Bouche à oreille</option>
                  <option value="behance">Behance</option>
                  <option value="linkedin">LinkedIn</option>
                  <option value="instagram">Instagram</option>
                  <option value="google">Google</option>
                  <option value="autre">Autre</option>
                </select>
              </div>

              <div className="form-bottom">
                <p className="form-note">Vos données restent sur votre portfolio et ne sont jamais transmises à des tiers.</p>
                <button
                  className={`form-submit${loading ? ' loading' : ''}`}
                  onClick={handleSubmit}
                >
                  {loading ? 'Envoi…' : 'Envoyer →'}
                </button>
              </div>
            </>
          ) : (
            <div className="success-state">
              <div className="success-icon">✓</div>
              <div className="success-title">MESSAGE ENVOYÉ !</div>
              <p className="success-sub">Merci pour votre message. Je vous reviens dans les 24h ouvrées avec un premier retour.</p>
            </div>
          )}
        </div>
      </div>

      {/* BOTTOM BAND */}
      <div className="bottom-band">
        {BAND_ITEMS.map(b => (
          <div className="band-item" key={b.num}>
            <div className="band-num">{b.num}</div>
            <div className="band-title">{b.title}</div>
            <p className="band-desc">{b.desc}</p>
          </div>
        ))}
      </div>

      <Footer />
    </>
  );
}
